// extracted by mini-css-extract-plugin
export default {"occupancy":"Occupancy_occupancy__tQkGR"};